/**
 * Broker /v1/resources rows arrive in heap order (no ORDER BY) and reshuffle
 * as heartbeats rewrite them, so every list derived from the payload must
 * sort. Oldest claim first, id as the tiebreak — shared by useServers() and
 * the source registry so "first server" means the same thing everywhere.
 */
export function compareServers(
  a: { claimedAt: string; id: string },
  b: { claimedAt: string; id: string },
): number {
  return a.claimedAt.localeCompare(b.claimedAt) || a.id.localeCompare(b.id);
}
